import { Center, Flex, Stack } from '@chakra-ui/react';
import { useRef } from 'react';

import useDetectFileType from '@/hooks/useDetectFileType';
import { usePartnerProvidedBackground } from '@/v5/@hooks/auth/login';
import {
    CONTENT_FLEX,
    useAuthLayoutBreakpoint,
} from '@/v5/@hooks/auth/login/useAuthLayoutBreakpoint';

import { AuthBackgroundImage } from '@/v5/components/atoms/Image/AuthBackgroundImage';
import { LoginLogo } from '@/v5/components/atoms/Logo/LoginLogo';
import { AuthFormProvider } from '@/v5/contexts/AuthFormContext';

function AuthLayout({ children }) {
    const authPageContainerRef = useRef(null);
    const backgroundOptions = {};
    const { minH, px, py } = useAuthLayoutBreakpoint();
    const { data, isLoading: _isLoading } = usePartnerProvidedBackground(
        authPageContainerRef,
        backgroundOptions,
    );
    const isLoading = typeof data !== 'undefined' && _isLoading; // bypass if background data is undefined

    const imgPath = data?.lightLogo;
    const imageFileType = useDetectFileType(
        import.meta.env.VITE_APP_IMAGE_BASE + imgPath,
    );
    const src = import.meta.env.VITE_APP_IMAGE_BASE + imgPath;

    return (
        <Flex minH={minH} align="flex-start">
            <AuthBackgroundImage
                ref={authPageContainerRef}
                isLoading={isLoading}
                aria-label="picture left"
                height="100vh"
                position="sticky"
                top="0"
            />
            <Center
                flex={{ base: '1', md: `${CONTENT_FLEX}` }}
                minH="100vh"
                maxH={{ base: 'none', md: '100vh' }}
                aria-label="form right"
                position="relative"
                overflowY={{ base: 'visible', md: 'auto' }}
                css={{
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#CBD5E0',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        background: '#A0AEC0',
                    },
                    '-ms-overflow-style': 'none',
                    scrollbarWidth: 'none',
                    scrollbarColor: '#CBD5E0 transparent',
                }}>
                <Stack
                    spacing="8"
                    px={px}
                    py={py}
                    width={`calc(100% / ${CONTENT_FLEX})`}
                    minH="100vh"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center">
                    <Stack spacing="6">
                        <LoginLogo
                            isLoading={isLoading}
                            src={src}
                            imageFileType={imageFileType}
                        />
                    </Stack>
                    <AuthFormProvider>{children}</AuthFormProvider>
                </Stack>
            </Center>
        </Flex>
    );
}

export { AuthLayout };
